export default "__VITE_ASSET__CFDjMI1s__"